import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "inline-flex overflow-hidden rounded-md border border-gray-300" }
const _hoisted_2 = ["aria-label", "disabled"]
const _hoisted_3 = ["value"]
const _hoisted_4 = ["aria-label", "disabled"]
const _hoisted_5 = {
  key: 0,
  class: "mt-2 text-sm text-gray-600"
}

import { computed, useId } from 'vue'


export default {
  __name: 'NumberStepper',
  props: {
  modelValue: { type: Number, default: null },
  name: { type: String, required: true },
  description: { type: String, default: '' },
  min: { type: Number, default: 0 },
  max: { type: Number, default: Infinity },
  step: { type: Number, default: 1 }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

const id = `stepper-${useId()}`
const lowerName = computed(() => props.name.charAt(0).toLowerCase() + props.name.slice(1))

const clamp = value => Math.min(props.max, Math.max(props.min, value))

const nudge = direction => emit('update:modelValue', clamp((props.modelValue ?? props.min) + direction * props.step))

const onInput = event => {
  const text = event.target.value.replace(/[^0-9]/g, '')
  emit('update:modelValue', text === '' ? null : Math.min(props.max, parseInt(text, 10)))
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("label", {
      for: id,
      class: "mb-2 block text-sm font-medium text-gray-700"
    }, _toDisplayString(__props.name), 1),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        type: "button",
        class: "h-10 w-10 bg-[#f6f7f9] text-lg text-gray-700 hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-40",
        "aria-label": `Fewer ${lowerName.value}`,
        disabled: __props.modelValue !== null && __props.modelValue <= __props.min,
        onClick: _cache[0] || (_cache[0] = $event => (nudge(-1)))
      }, " − ", 8, _hoisted_2),
      _createElementVNode("input", {
        id: id,
        type: "text",
        inputmode: "numeric",
        class: "w-12 border-x border-gray-300 text-center text-sm font-semibold text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-gray-900",
        value: __props.modelValue ?? '',
        onInput: onInput
      }, null, 40, _hoisted_3),
      _createElementVNode("button", {
        type: "button",
        class: "h-10 w-10 bg-[#f6f7f9] text-lg text-gray-700 hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-40",
        "aria-label": `More ${lowerName.value}`,
        disabled: __props.modelValue !== null && __props.modelValue >= __props.max,
        onClick: _cache[1] || (_cache[1] = $event => (nudge(1)))
      }, " + ", 8, _hoisted_4)
    ]),
    (__props.description)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(__props.description), 1))
      : _createCommentVNode("", true)
  ]))
}
}

}